// extracted by mini-css-extract-plugin
export var avatarContainer = "_9i-0";
export var avatarTypingWave = "_9i-i";
export var gray = "_9i-f";
export var green = "_9i-c";
export var icon = "_9i-9";
export var image = "_9i-1";
export var lg = "_9i-6";
export var md = "_9i-5";
export var presenceDot = "_9i-b";
export var red = "_9i-d";
export var sm = "_9i-4";
export var status = "_9i-a";
export var typingDot = "_9i-h";
export var typingPill = "_9i-g";
export var xl = "_9i-7";
export var xs = "_9i-3";
export var xxl = "_9i-8";
export var xxs = "_9i-2";
export var yellow = "_9i-e";